module.exports = "<div class=\"cawarning\">\r\n  <div class=\"content-block\">\r\n    <h1>California Warning -</h1>\r\n    <h2>Proposition 65</h2>\r\n    <p>\r\n      Risk of cancer from exposure to lead, phthalates, BPA and reproductive harm from \r\n      exposure to lead, phalates, BPA. See \r\n      <a href=\"https://www.p65warnings.ca.gov/\" target=\"_blank\">www.p65warnings.ca.gov</a>.\r\n    </p>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/static/ca-warn.html
// module id = 162
// module chunks = 0